import "./Web.scss";
import { FaReact, FaNodeJs, FaWordpress, FaHtml5, FaCss3Alt, FaJs } from "react-icons/fa";

export default function Web() {
  return (
    <div className="web">
      <h1>Services de Développement Web</h1>

      <p>
        J’accompagne vos projets digitaux de la conception à la mise en production,
        en veillant à la performance, à l’accessibilité et à l’optimisation SEO.
      </p>

      <ul>
        <li>Sites web professionnels pour entreprises</li>
        <li>Design moderne et responsive</li>
        <li>Pages d’atterrissage (Landing Pages)</li>
        <li>Refonte de site internet</li>
        <li>Support technique</li>
      </ul>

      <p>
        Je crée des sites web clairs, rapides et optimisés pour le référencement (SEO),
        parfaitement adaptés aux besoins de votre activité.
      </p>

      {/* Technologies */}
      <div className="technologies">
        <h2>Technologies utilisées</h2>

        <div className="tech_container">
          <div className="tech"><FaReact /> <span>React</span></div>
          <div className="tech"><FaNodeJs /> <span>Node.js</span></div>
          <div className="tech"><FaWordpress /> <span>WordPress</span></div>
          <div className="tech"><FaHtml5 /> <span>HTML5</span></div>
          <div className="tech"><FaCss3Alt /> <span>CSS3</span></div>
          <div className="tech"><FaJs /> <span>JavaScript</span></div>
        </div>
      </div>
    </div>
  );
}